import { apiSlice } from './apiSlice.js';
import { SMS_URL } from '../constants.js';

export const smsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendSms: builder.mutation({
      query: ({phone, message}) => ({
        url: SMS_URL,
        method: 'POST',
        body: {phone, message},
      }),
      invalidatesTags: ['Sms']
    }),
    sendOTP: builder.mutation({
      query: ({orderId}) => ({
        url: `${SMS_URL}/sendotp`,
        method: 'POST',
        body: {orderId},
      }),
      invalidatesTags: ['Sms']
    }),
    verifyOTP: builder.mutation({
      query: ({orderId, otp}) => ({
        url: `${SMS_URL}/verifyotp`,
        method: 'POST',
        body: {orderId, otp},
      }),
      invalidatesTags: ['Sms']
    })
  })
});

export const {
  useSendSmsMutation,
  useSendOTPMutation,
  useVerifyOTPMutation
} = smsApiSlice;